import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from 'survey-react-ui';
import React from 'react';
import { createCountryWidgetModel } from './model';
import { utils } from '@deeptrue-frontend/ui';

export const registerCountryWidget = () => {
  createCountryWidgetModel();

  class SurveyQuestionCountrywidget extends SurveyQuestionElementBase {
    constructor(props: any) {
      super(props);
      this.state = { value: this.question.value };
    }
    get question() {
      return this.questionBase;
    }
    get value() {
      return this.question.value;
    }

    get type() {
      // @ts-ignore
      return this.question.countrywidgetType;
    }
    handleCountrywidgetChange = (data: any) => {
      this.question.value = data;
    };

    // support readOnly and designMode
    get style() {
      return this.question.getPropertyValue('readOnly') ||
        this.question.isDesignMode
        ? {
            pointerEvents: 'none',
          }
        : undefined;
    }

    renderElement() {
      return (
        // @ts-ignore
        <utils.survey.widgets.CountryWidgetV2
          onChange={this.handleCountrywidgetChange}
          // @ts-ignore
          question={this.question}
        />
      );
    }
  }

  ReactQuestionFactory.Instance.registerQuestion(
    'dtcountrynew',
    (props: any) => {
      return React.createElement(SurveyQuestionCountrywidget, props);
    }
  );
};
